/**
 * @generated SignedSource<<72cd99b9ace55853c50b223b14adc073>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemLocation_item$data = {
  readonly address: {
    readonly displayCountry: string | null;
  } | null;
  readonly isInEurope: boolean | null;
  readonly " $fragmentType": "ItemLocation_item";
};
export type ItemLocation_item$key = {
  readonly " $data"?: ItemLocation_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemLocation_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemLocation_item",
  "selections": [
    {
      "alias": "isInEurope",
      "args": [
        {
          "kind": "Literal",
          "name": "regionName",
          "value": "Europe"
        }
      ],
      "kind": "ScalarField",
      "name": "isInRegion",
      "storageKey": "isInRegion(regionName:\"Europe\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayCountry",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "533ca64a5773b93466c28ecc2d8867a1";

export default node;
